import { Component, Input } from '@angular/core';
import { ElevatorBankProcessed, ElevatorTypes } from './elevator-banks.model';

@Component({
  selector: 'sp-elevator-banks',
  templateUrl: './elevator-banks.component.html',
  styleUrls: ['./elevator-banks.component.scss'],
  standalone: false,
})
export class ElevatorBanksComponent {
  @Input() elevatorBankData: ElevatorBankProcessed[] = [];
  elevatorType = ElevatorTypes;

  showElevatorDialog() {
    // TODO: open elevator info dialog
  }
}
